// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3yMqd","footerLine":"footer-module--footerLine--uk2Av"};